export function getTags(state) {
  return state.tags;
}